<template>
  <div>
    <modal
      name="deactivate_feedback_modal"
      height="auto"
      width="360px"
      style="z-index:9999;"
      @closed="deactivate_feedback_modal_on_closed"
    >
      <div class="modal_close_cont">
        <button @click="$modal.hide('deactivate_feedback_modal')"></button>
      </div>
      <div class="mbox bg-light shadow mb0">
        <div class="form">
          <div class="wpc-form-row">
            <div class="mb10" style="text-align:center; font-size:16px;">
              <span
                v-html="
                  Tsprintf(
                    /* translators: 1: html-tag */
                    T__(
                      'If you have a moment, please share why %1$s you are deactivating'
                    ),
                    '<br>'
                  )
                "
              >
              </span>
              WPCal.io
            </div>
          </div>
          <ul class="selector block mt10 exit-survey">
            <li v-for="(reason, index) in reasons" :key="index">
              <input
                type="radio"
                name="wpcal_deactivate_reason"
                :value="reason.value"
                v-model="form.reason"
                :id="'wpcal_deactivate_reason_' + index"
                @focus="ref_focus('deactivate_reason_user_descr_' + index)"
              />
              <label
                style="font-size:15px;"
                :for="'wpcal_deactivate_reason_' + index"
                >{{ reason.label }}
                <div
                  v-if="
                    form.reason == reason.value &&
                      reason.hasOwnProperty('user_descr')
                  "
                >
                  <label
                    style="display: block; font-size:14px; margin: 5px 0; color: #7c7d9c; font-size: 13px; white-space:normal;"
                    v-if="reason.user_descr_label"
                    :for="'wpcal_deactivate_reason_user_descr_' + index"
                    >{{ reason.user_descr_label }}</label
                  >
                  <div
                    v-if="reason.value == 'having_issues'"
                    style="margin-bottom:5px;"
                  >
                    <div
                      style="font-size: 13px; color: rgb(124, 125, 156); white-space: normal;"
                    >
                      {{
                        T__(
                          "Please contact our support team for further assistance."
                        )
                      }}
                    </div>
                    <div>
                      <a
                        style="font-size:14px;"
                        href="https://wpcal.io/support/"
                        target="_blank"
                        @click="$emit('change-dynamic-component', '')"
                        >https://wpcal.io/support/
                        <span style="float: right;">&nearr;</span></a
                      >
                    </div>
                  </div>

                  <textarea
                    :id="'wpcal_deactivate_reason_user_descr_' + index"
                    :ref="'deactivate_reason_user_descr_' + index"
                    v-model="form.user_descr"
                  /></div
              ></label>
            </li>
          </ul>
        </div>
        <div class="wpc-form-row">
          <button
            style="width: 100%;"
            type="button"
            class="wpc-btn primary lg mt20"
            :disabled="!modal_deactivate_btn_is_enabled"
            @click="submit_form_deactivate"
          >
            {{ T__("Submit &amp; Deactivate") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";

export default {
  data() {
    return {
      reasons: [
        {
          value: "no_longer_needed",
          label: this.T__("I no longer need this plugin")
        },
        {
          value: "found_better_plugin",
          label: this.T__("I found a better plugin"),
          user_descr_label: this.T__(
            "Is it possible to provide the plugin's name? It will help us understand what are missing."
          ),
          user_descr: ""
        },
        {
          value: "having_issues",
          label: this.T__("I am facing some issues with the plugin"),
          user_descr_label: this.T__(
            "We would really love an opportunity to fix any issue and help you succeed with the plugin."
          ),
          user_descr: ""
        },
        {
          value: "feature_missing",
          label: this.T__("Feature(s) I need are missing"),
          user_descr_label: this.T__("Can you please tell us what's missing?"),
          user_descr: ""
        },
        {
          value: "temporary_deactivate",
          label: this.T__("It's a temporary deactivation")
        },
        {
          value: "other",
          label: "Other",
          user_descr_label: this.T__("Can you please give us more details?"),
          user_descr: ""
        }
      ],
      form: {
        reason: "",
        user_descr: ""
      },
      modal_deactivate_btn_is_enabled: true
    };
  },
  methods: {
    show_deactivate_feedback_modal() {
      this.$modal.show("deactivate_feedback_modal");
    },
    submit_form_deactivate() {
      this.modal_deactivate_btn_is_enabled = false;

      let form_details = Object.assign({}, this.form);
      if (
        form_details.reason &&
        (form_details.reason == "no_longer_needed" ||
          form_details.reason == "temporary_deactivate")
      ) {
        form_details.user_descr = "";
      }

      let wpcal_request = {};
      wpcal_request["submit_plugin_deactivate_feedback"] = {
        form: form_details
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, qs.stringify(post_data))
        .then(response => {
          response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          setTimeout(() => {
            //time out, so that it deactivate will also starts
            this.modal_deactivate_btn_is_enabled = true;
          }, 4000);
          wpcal_deactivate_feedback_shown = true; //even the form not able to show, next time let it consider it has shown
          window.jQuery("[data-slug=wpcal] .deactivate a")[0].click();
        });
    },
    deactivate_feedback_modal_on_closed() {
      this.$emit("change-dynamic-component", "");
    },
    ref_focus(ref_name) {
      setTimeout(() => {
        if (Array.isArray(this.$refs[ref_name])) {
          this.$refs[ref_name][0].focus();
        } else {
          this.$refs[ref_name].focus();
        }
      }, 100);
    }
  },
  mounted() {
    this.show_deactivate_feedback_modal();
  }
};
</script>
